import * as S from './Title.style';

export { default as Title } from './Title';
export * from './Title.types';
export { S };
